export function getTimezoneShortName(): string {
  return localStorage.getItem('userTimezoneShort') || '';
}

export function parseLocalDateTime(dateTimeString: string): number {
  const cleanDateString = dateTimeString.replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '');
  const parts = cleanDateString.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?/);
  if (parts) {
    const [, year, month, day, hours, minutes, seconds, ms] = parts;
    const localDate = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hours, 10),
      parseInt(minutes, 10),
      parseInt(seconds, 10),
      parseInt(ms || '0', 10)
    );
    return localDate.getTime();
  }
  return new Date(dateTimeString).getTime();
}

export function formatLocalDateTime(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}
